module.exports = {
    CustodyIndex: [
        {
            'anonymous': false,
            'inputs': [
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'strategy',
                    'type': 'address'
                }
            ],
            'name': 'DisableStrategy',
            'type': 'event'
        },
        {
            'anonymous': false,
            'inputs': [
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'strategy',
                    'type': 'address'
                }
            ],
            'name': 'EnableStrategy',
            'type': 'event'
        },
        {
            'anonymous': false,
            'inputs': [
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'owner',
                    'type': 'address'
                },
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'vault',
                    'type': 'address'
                },
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'strategy',
                    'type': 'address'
                },
                {
                    'indexed': false,
                    'internalType': 'string',
                    'name': 'name',
                    'type': 'string'
                }
            ],
            'name': 'NewVault',
            'type': 'event'
        },
        {
            'anonymous': false,
            'inputs': [
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'previousOwner',
                    'type': 'address'
                },
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'newOwner',
                    'type': 'address'
                }
            ],
            'name': 'OwnershipProposed',
            'type': 'event'
        },
        {
            'anonymous': false,
            'inputs': [
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'previousOwner',
                    'type': 'address'
                },
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'newOwner',
                    'type': 'address'
                }
            ],
            'name': 'OwnershipTransferred',
            'type': 'event'
        },
        {
            'anonymous': false,
            'inputs': [
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'vault',
                    'type': 'address'
                },
                {
                    'indexed': false,
                    'internalType': 'string',
                    'name': 'name',
                    'type': 'string'
                }
            ],
            'name': 'RenameVault',
            'type': 'event'
        },
        {
            'inputs': [],
            'name': 'acceptOwnership',
            'outputs': [],
            'stateMutability': 'nonpayable',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': '_strategy',
                    'type': 'address'
                },
                {
                    'internalType': 'string',
                    'name': '_name',
                    'type': 'string'
                }
            ],
            'name': 'createVault',
            'outputs': [
                {
                    'internalType': 'address',
                    'name': 'vault',
                    'type': 'address'
                }
            ],
            'stateMutability': 'nonpayable',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': '_strategy',
                    'type': 'address'
                }
            ],
            'name': 'disableStrategy',
            'outputs': [],
            'stateMutability': 'nonpayable',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': '_strategy',
                    'type': 'address'
                }
            ],
            'name': 'enableStrategy',
            'outputs': [],
            'stateMutability': 'nonpayable',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': '_addr',
                    'type': 'address'
                }
            ],
            'name': 'isOwner',
            'outputs': [
                {
                    'internalType': 'bool',
                    'name': '',
                    'type': 'bool'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': '_strategy',
                    'type': 'address'
                }
            ],
            'name': 'isStrategyEnable',
            'outputs': [
                {
                    'internalType': 'bool',
                    'name': '',
                    'type': 'bool'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [],
            'name': 'owner',
            'outputs': [
                {
                    'internalType': 'address',
                    'name': '',
                    'type': 'address'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [],
            'name': 'pendingOwner',
            'outputs': [
                {
                    'internalType': 'address',
                    'name': '',
                    'type': 'address'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': 'newOwner',
                    'type': 'address'
                }
            ],
            'name': 'proposeOwnership',
            'outputs': [],
            'stateMutability': 'nonpayable',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': '_vault',
                    'type': 'address'
                },
                {
                    'internalType': 'string',
                    'name': '_name',
                    'type': 'string'
                }
            ],
            'name': 'renameVault',
            'outputs': [],
            'stateMutability': 'nonpayable',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'uint256',
                    'name': '',
                    'type': 'uint256'
                }
            ],
            'name': 'strategies',
            'outputs': [
                {
                    'internalType': 'address',
                    'name': '',
                    'type': 'address'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': '',
                    'type': 'address'
                }
            ],
            'name': 'strategiesEnable',
            'outputs': [
                {
                    'internalType': 'uint8',
                    'name': '',
                    'type': 'uint8'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [],
            'name': 'strategiesSize',
            'outputs': [
                {
                    'internalType': 'uint256',
                    'name': '',
                    'type': 'uint256'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': 'newOwner',
                    'type': 'address'
                }
            ],
            'name': 'transferOwnership',
            'outputs': [],
            'stateMutability': 'nonpayable',
            'type': 'function'
        },
        {
            'inputs': [],
            'name': 'valutsSize',
            'outputs': [
                {
                    'internalType': 'uint256',
                    'name': '',
                    'type': 'uint256'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'uint256',
                    'name': '',
                    'type': 'uint256'
                }
            ],
            'name': 'vaults',
            'outputs': [
                {
                    'internalType': 'address',
                    'name': '',
                    'type': 'address'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': '',
                    'type': 'address'
                }
            ],
            'name': 'vaultsName',
            'outputs': [
                {
                    'internalType': 'string',
                    'name': '',
                    'type': 'string'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        }
    ],
    Vault: [
        {
            'inputs': [],
            'stateMutability': 'nonpayable',
            'type': 'constructor'
        },
        {
            'anonymous': false,
            'inputs': [
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'owner',
                    'type': 'address'
                },
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'harvestor',
                    'type': 'address'
                }
            ],
            'name': 'AddHarvestor',
            'type': 'event'
        },
        {
            'anonymous': false,
            'inputs': [
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'owner',
                    'type': 'address'
                },
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'operator',
                    'type': 'address'
                }
            ],
            'name': 'AddOperator',
            'type': 'event'
        },
        {
            'anonymous': false,
            'inputs': [
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'owner',
                    'type': 'address'
                },
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'harvestor',
                    'type': 'address'
                }
            ],
            'name': 'DelHarvestor',
            'type': 'event'
        },
        {
            'anonymous': false,
            'inputs': [
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'owner',
                    'type': 'address'
                },
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'operator',
                    'type': 'address'
                }
            ],
            'name': 'DelOperator',
            'type': 'event'
        },
        {
            'anonymous': false,
            'inputs': [
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'erc20',
                    'type': 'address'
                },
                {
                    'indexed': false,
                    'internalType': 'uint256',
                    'name': 'tokenAmt',
                    'type': 'uint256'
                },
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'to',
                    'type': 'address'
                }
            ],
            'name': 'LogWithdraw',
            'type': 'event'
        },
        {
            'anonymous': false,
            'inputs': [
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'previousOwner',
                    'type': 'address'
                },
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'newOwner',
                    'type': 'address'
                }
            ],
            'name': 'OwnershipProposed',
            'type': 'event'
        },
        {
            'anonymous': false,
            'inputs': [
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'previousOwner',
                    'type': 'address'
                },
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'newOwner',
                    'type': 'address'
                }
            ],
            'name': 'OwnershipTransferred',
            'type': 'event'
        },
        {
            'stateMutability': 'payable',
            'type': 'fallback'
        },
        {
            'inputs': [],
            'name': 'acceptOwnership',
            'outputs': [],
            'stateMutability': 'nonpayable',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': '_op',
                    'type': 'address'
                }
            ],
            'name': 'addHarvestor',
            'outputs': [],
            'stateMutability': 'nonpayable',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': '_op',
                    'type': 'address'
                }
            ],
            'name': 'addOperator',
            'outputs': [],
            'stateMutability': 'nonpayable',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': '_op',
                    'type': 'address'
                }
            ],
            'name': 'delHarvestor',
            'outputs': [],
            'stateMutability': 'nonpayable',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': '_op',
                    'type': 'address'
                }
            ],
            'name': 'delOperator',
            'outputs': [],
            'stateMutability': 'nonpayable',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'uint256',
                    'name': '',
                    'type': 'uint256'
                }
            ],
            'name': 'harvestorList',
            'outputs': [
                {
                    'internalType': 'address',
                    'name': '',
                    'type': 'address'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [],
            'name': 'harvestorSize',
            'outputs': [
                {
                    'internalType': 'uint256',
                    'name': '',
                    'type': 'uint256'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': '',
                    'type': 'address'
                }
            ],
            'name': 'harvestors',
            'outputs': [
                {
                    'internalType': 'uint8',
                    'name': '',
                    'type': 'uint8'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [],
            'name': 'index_factory',
            'outputs': [
                {
                    'internalType': 'address',
                    'name': '',
                    'type': 'address'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': '_owner',
                    'type': 'address'
                },
                {
                    'internalType': 'address',
                    'name': '_strategy',
                    'type': 'address'
                }
            ],
            'name': 'initialize',
            'outputs': [],
            'stateMutability': 'nonpayable',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': '_addr',
                    'type': 'address'
                }
            ],
            'name': 'isHarvestor',
            'outputs': [
                {
                    'internalType': 'bool',
                    'name': '',
                    'type': 'bool'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': '_addr',
                    'type': 'address'
                }
            ],
            'name': 'isOperator',
            'outputs': [
                {
                    'internalType': 'bool',
                    'name': '',
                    'type': 'bool'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': '_addr',
                    'type': 'address'
                }
            ],
            'name': 'isOwner',
            'outputs': [
                {
                    'internalType': 'bool',
                    'name': '',
                    'type': 'bool'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'uint256',
                    'name': '',
                    'type': 'uint256'
                }
            ],
            'name': 'operatorList',
            'outputs': [
                {
                    'internalType': 'address',
                    'name': '',
                    'type': 'address'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [],
            'name': 'operatorSize',
            'outputs': [
                {
                    'internalType': 'uint256',
                    'name': '',
                    'type': 'uint256'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': '',
                    'type': 'address'
                }
            ],
            'name': 'operators',
            'outputs': [
                {
                    'internalType': 'uint8',
                    'name': '',
                    'type': 'uint8'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [],
            'name': 'owner',
            'outputs': [
                {
                    'internalType': 'address',
                    'name': '',
                    'type': 'address'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [],
            'name': 'pendingOwner',
            'outputs': [
                {
                    'internalType': 'address',
                    'name': '',
                    'type': 'address'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': 'newOwner',
                    'type': 'address'
                }
            ],
            'name': 'proposeOwnership',
            'outputs': [],
            'stateMutability': 'nonpayable',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': '_strategy',
                    'type': 'address'
                }
            ],
            'name': 'setStrategy',
            'outputs': [],
            'stateMutability': 'nonpayable',
            'type': 'function'
        },
        {
            'inputs': [],
            'name': 'strategy',
            'outputs': [
                {
                    'internalType': 'address',
                    'name': '',
                    'type': 'address'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': 'newOwner',
                    'type': 'address'
                }
            ],
            'name': 'transferOwnership',
            'outputs': [],
            'stateMutability': 'nonpayable',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': 'erc20',
                    'type': 'address'
                },
                {
                    'internalType': 'uint256',
                    'name': 'tokenAmt',
                    'type': 'uint256'
                }
            ],
            'name': 'withdraw',
            'outputs': [],
            'stateMutability': 'payable',
            'type': 'function'
        },
        {
            'stateMutability': 'payable',
            'type': 'receive'
        }
    ],
    Strategy: [
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "_amount",
                    "type": "uint256"
                }
            ],
            "name": "earn",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "_amount",
                    "type": "uint256"
                }
            ],
            "name": "exit",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "exit",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint8",
                    "name": "_type",
                    "type": "uint8"
                }
            ],
            "name": "harvest",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "investToken",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "strategyName",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ],
    ERC20: [
        {
            'inputs': [
                {
                    'internalType': 'string',
                    'name': 'name_',
                    'type': 'string'
                },
                {
                    'internalType': 'string',
                    'name': 'symbol_',
                    'type': 'string'
                }
            ],
            'stateMutability': 'nonpayable',
            'type': 'constructor'
        },
        {
            'anonymous': false,
            'inputs': [
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'owner',
                    'type': 'address'
                },
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'spender',
                    'type': 'address'
                },
                {
                    'indexed': false,
                    'internalType': 'uint256',
                    'name': 'value',
                    'type': 'uint256'
                }
            ],
            'name': 'Approval',
            'type': 'event'
        },
        {
            'anonymous': false,
            'inputs': [
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'from',
                    'type': 'address'
                },
                {
                    'indexed': true,
                    'internalType': 'address',
                    'name': 'to',
                    'type': 'address'
                },
                {
                    'indexed': false,
                    'internalType': 'uint256',
                    'name': 'value',
                    'type': 'uint256'
                }
            ],
            'name': 'Transfer',
            'type': 'event'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': 'owner',
                    'type': 'address'
                },
                {
                    'internalType': 'address',
                    'name': 'spender',
                    'type': 'address'
                }
            ],
            'name': 'allowance',
            'outputs': [
                {
                    'internalType': 'uint256',
                    'name': '',
                    'type': 'uint256'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': 'spender',
                    'type': 'address'
                },
                {
                    'internalType': 'uint256',
                    'name': 'amount',
                    'type': 'uint256'
                }
            ],
            'name': 'approve',
            'outputs': [
                {
                    'internalType': 'bool',
                    'name': '',
                    'type': 'bool'
                }
            ],
            'stateMutability': 'nonpayable',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': 'account',
                    'type': 'address'
                }
            ],
            'name': 'balanceOf',
            'outputs': [
                {
                    'internalType': 'uint256',
                    'name': '',
                    'type': 'uint256'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [],
            'name': 'decimals',
            'outputs': [
                {
                    'internalType': 'uint8',
                    'name': '',
                    'type': 'uint8'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': 'spender',
                    'type': 'address'
                },
                {
                    'internalType': 'uint256',
                    'name': 'subtractedValue',
                    'type': 'uint256'
                }
            ],
            'name': 'decreaseAllowance',
            'outputs': [
                {
                    'internalType': 'bool',
                    'name': '',
                    'type': 'bool'
                }
            ],
            'stateMutability': 'nonpayable',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': 'spender',
                    'type': 'address'
                },
                {
                    'internalType': 'uint256',
                    'name': 'addedValue',
                    'type': 'uint256'
                }
            ],
            'name': 'increaseAllowance',
            'outputs': [
                {
                    'internalType': 'bool',
                    'name': '',
                    'type': 'bool'
                }
            ],
            'stateMutability': 'nonpayable',
            'type': 'function'
        },
        {
            'inputs': [],
            'name': 'name',
            'outputs': [
                {
                    'internalType': 'string',
                    'name': '',
                    'type': 'string'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [],
            'name': 'symbol',
            'outputs': [
                {
                    'internalType': 'string',
                    'name': '',
                    'type': 'string'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [],
            'name': 'totalSupply',
            'outputs': [
                {
                    'internalType': 'uint256',
                    'name': '',
                    'type': 'uint256'
                }
            ],
            'stateMutability': 'view',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': 'recipient',
                    'type': 'address'
                },
                {
                    'internalType': 'uint256',
                    'name': 'amount',
                    'type': 'uint256'
                }
            ],
            'name': 'transfer',
            'outputs': [
                {
                    'internalType': 'bool',
                    'name': '',
                    'type': 'bool'
                }
            ],
            'stateMutability': 'nonpayable',
            'type': 'function'
        },
        {
            'inputs': [
                {
                    'internalType': 'address',
                    'name': 'sender',
                    'type': 'address'
                },
                {
                    'internalType': 'address',
                    'name': 'recipient',
                    'type': 'address'
                },
                {
                    'internalType': 'uint256',
                    'name': 'amount',
                    'type': 'uint256'
                }
            ],
            'name': 'transferFrom',
            'outputs': [
                {
                    'internalType': 'bool',
                    'name': '',
                    'type': 'bool'
                }
            ],
            'stateMutability': 'nonpayable',
            'type': 'function'
        }
    ],
    Safe: [
    {
      "inputs": [
        {
          "internalType": "address payable",
          "name": "_safe",
          "type": "address"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "_contract",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "string[]",
          "name": "funcList",
          "type": "string[]"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "sender",
          "type": "address"
        }
      ],
      "name": "AssocContractFuncs",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "delegate",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "sender",
          "type": "address"
        }
      ],
      "name": "DelegateAdded",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "delegate",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "sender",
          "type": "address"
        }
      ],
      "name": "DelegateRemoved",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "_contract",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "string[]",
          "name": "funcList",
          "type": "string[]"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "sender",
          "type": "address"
        }
      ],
      "name": "DissocContractFuncs",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "enum Enum.Operation",
          "name": "operation",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "bytes",
          "name": "data",
          "type": "bytes"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "sender",
          "type": "address"
        }
      ],
      "name": "ExecTransaction",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "previousOwner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "OwnershipTransferred",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "sender",
          "type": "address"
        }
      ],
      "name": "RoleAdded",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "delegate",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "sender",
          "type": "address"
        }
      ],
      "name": "RoleGranted",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "delegate",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "sender",
          "type": "address"
        }
      ],
      "name": "RoleRevoked",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "NAME",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "ROLE_HARVESTER",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "VERSION",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        }
      ],
      "name": "addRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "_contract",
          "type": "address"
        },
        {
          "internalType": "string[]",
          "name": "funcList",
          "type": "string[]"
        }
      ],
      "name": "assocRoleWithContractFuncs",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address[]",
          "name": "toList",
          "type": "address[]"
        },
        {
          "internalType": "bytes[]",
          "name": "dataList",
          "type": "bytes[]"
        }
      ],
      "name": "batchExecTransactions",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "_contract",
          "type": "address"
        },
        {
          "internalType": "string[]",
          "name": "funcList",
          "type": "string[]"
        }
      ],
      "name": "dissocRoleFromContractFuncs",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "dumpDelegatesAndRoles",
      "outputs": [
        {
          "internalType": "bytes[]",
          "name": "",
          "type": "bytes[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "dumpFuncsAndRolesForAllContracts",
      "outputs": [
        {
          "internalType": "bytes[]",
          "name": "",
          "type": "bytes[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_contract",
          "type": "address"
        }
      ],
      "name": "dumpFuncsAndRolesForContract",
      "outputs": [
        {
          "internalType": "bytes[]",
          "name": "",
          "type": "bytes[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "bytes",
          "name": "data",
          "type": "bytes"
        }
      ],
      "name": "execTransaction",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getAllContracts",
      "outputs": [
        {
          "internalType": "address[]",
          "name": "",
          "type": "address[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getAllDelegates",
      "outputs": [
        {
          "internalType": "address[]",
          "name": "",
          "type": "address[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getAllRoles",
      "outputs": [
        {
          "internalType": "bytes32[]",
          "name": "",
          "type": "bytes32[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_contract",
          "type": "address"
        }
      ],
      "name": "getFuncsByContract",
      "outputs": [
        {
          "internalType": "bytes4[]",
          "name": "",
          "type": "bytes4[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_contract",
          "type": "address"
        },
        {
          "internalType": "bytes4",
          "name": "funcSelector",
          "type": "bytes4"
        }
      ],
      "name": "getRolesByContractFunction",
      "outputs": [
        {
          "internalType": "bytes32[]",
          "name": "",
          "type": "bytes32[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "delegate",
          "type": "address"
        }
      ],
      "name": "getRolesByDelegate",
      "outputs": [
        {
          "internalType": "bytes32[]",
          "name": "",
          "type": "bytes32[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "delegate",
          "type": "address"
        }
      ],
      "name": "grantRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "delegate",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "bytes4",
          "name": "selector",
          "type": "bytes4"
        }
      ],
      "name": "hasPermission",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "delegate",
          "type": "address"
        }
      ],
      "name": "hasRole",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "delegate",
          "type": "address"
        }
      ],
      "name": "isDelegate",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "owner",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "renounceOwnership",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "delegate",
          "type": "address"
        }
      ],
      "name": "revokeRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "transferOwnership",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    }
  ],
}
